export function IconDragIndicator(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={35} viewBox="0 0 24 35" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="currentColor" fill="none" fillRule="evenodd">
        <path
          d="M6.416 15.968a7.11 7.11 0 01-.95-3.565c0-3.83 2.993-6.935 6.684-6.935 3.69 0 6.683 3.105 6.683 6.935a7.107 7.107 0 01-1.141 3.879M23.3 12.403h-4.467"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path strokeLinecap="round" d="M22.225 10.58l1.075 1.794-1.216 1.852" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12.149 1v4.468" />
        <path strokeLinecap="round" d="M10.325 2.075L12.12 1l1.852 1.216" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M1 12.403h4.467" />
        <path strokeLinecap="round" d="M2.075 14.226L1 12.431l1.216-1.851" />
        <path
          d="M12.105 11.935c1.147 0 2.06.829 2.06 1.872v6.595l6.137.037s2.407.338 2.407 2.776v6.113c0 1.434-.553 5.165-3.535 5.165-1.872 0-5.095-.008-6.197-.008-4.61 0-5.762-4.45-5.762-5.873v-5.396c0-1.33.607-2.843 2.832-3.024v6.512-12.897c0-1.043.912-1.872 2.058-1.872z"
          strokeLinejoin="round"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14.165 20.422v3.815M17.298 20.422v3.815M20.302 20.72v3.518"
        />
      </g>
    </svg>
  );
}
